import type { Avatar } from '../types/db';

export default function AvatarCard({
  avatar,
  isSelected,
  onSelect,
}: {
  avatar: Avatar;
  isSelected?: boolean;
  onSelect?: () => void;
}) {
  return (
    <div
      onClick={onSelect}
      className={`cursor-pointer rounded-xl border bg-white p-4 transition ${
        isSelected
          ? 'border-brand-500 ring-1 ring-brand-500'
          : 'border-slate-200 hover:border-slate-300'
      }`}
    >
      <div className="aspect-video overflow-hidden rounded-lg bg-slate-100">
        <img
          src={avatar.preview_url}
          alt={avatar.name}
          className="h-full w-full object-cover"
          loading="lazy"
        />
      </div>
      <div className="mt-3 flex items-center justify-between">
        <div>
          <h3 className="text-sm font-semibold text-slate-900">
            {avatar.name}
          </h3>
          <p className="text-xs text-slate-500">
            {avatar.client_id === null ? 'Libreria VoiceKit' : 'Custom cliente'}
          </p>
        </div>
        {isSelected && (
          <span className="rounded-full bg-brand-50 px-2 py-0.5 text-xs font-medium text-brand-700">
            Selezionato
          </span>
        )}
      </div>
    </div>
  );
}
